module.exports = __webpack_public_path__ + "img/rangeHead.7a342246.png";